<div class="modal active">
  <div class="modal__container modal__container--lg" style="top: 5%;">
    <div class="fields">

      <h2>{{ modalTitle }}</h2>
      <div class="close" (click)="bsModalRef.hide()">
        <img src="/assets/img/close-white.svg" alt="" />
      </div>

      <div class="fields__container">
        <form (ngSubmit)="submit()" autocomplete="off" id="userApprovalForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="table-fields">

                <!-- Users Table with Collapse -->
                <div style="margin-bottom: 20px;">
                  <label
                    [ngClass]="[colapsableLabelUsersList ? 'active' : '', 'colapsable']"
                    (click)="toggleUsersTable()"
                    style="cursor: pointer;">
                    Selected User(s) ({{ users.length }})
                  </label>

                  <div [ngClass]="[colapsableDivUsersList ? 'active' : '', 'colapsable']">
                    <div class="user-approval-table-scroll">
                      <table>
                        <thead>
                          <tr>
                            <th>User Name</th>
                            <th>Email</th>
                            <th>Status</th>
                            <th>Expiry date</th>
                            <th>Ref. License</th>
                            <th>Agreement Type</th>
                            <th>Agreement Duration</th>
                            <th>Payment Status</th>
                            <th>Role</th>
                            <th>Org Name</th>
                            <th>Org Type</th>
                            <th>Country</th>
                            <th>Admin Manager</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr *ngFor="let user of users">
                            <td>{{ user.userName }}</td>
                            <td>{{ user.email }}</td>
                            <td>{{ user.userState }}</td>
                            <td>{{ user.dueDate || '-' }}</td>
                            <td>{{ user.referenceLicense || '-' }}</td>
                            <td>{{ user.agreementType || '-' }}</td>
                            <td>{{ user.agreementDuration || '-' }}</td>
                            <td>{{ user.paymentStatus || '-' }}</td>
                            <td>{{ user.role || '-' }}</td>
                            <td>{{ user.organizationName || '-' }}</td>
                            <td>{{ user.organizationType || '-' }}</td>
                            <td>{{ user.country || '-' }}</td>
                            <td>{{ user.adminManager || '-' }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <!-- Side by Side Layout: State on Left, Edit Details on Right -->
                <div style="display: flex; gap: 30px; margin-top: 20px; border-top: 2px solid #ddd; padding-top: 20px;">

                  <!-- Left Column: State & License Management -->
                  <div style="flex: 1; min-width: 0;">
                    <div class="title" style="margin-bottom: 20px;">
                       <h4>Status & License Management</h4>
                      <span> </span>
                    </div>

                    <!-- Current State Information -->
                    <div class="current-state-info">
                      <div class="info-row">
                          <label for="" style="width: 140px; min-width: 140px; margin-right: 10px;">Status</label>
                        <span [ngClass]="['state-badge', getStateBadgeClass()]">{{ currentState }}</span>
                      </div>




                      <!-- New State and License Management (moved inside) -->
                      <div class="info-row">
                          <label for="" style="width: 140px; min-width: 140px; margin-right: 10px;">New Status</label>
                        <select [(ngModel)]="form.newState"
                                name="newState"
                                (change)="onStateChange($event.target.value)">
                          <option value="">-- Keep current state --</option>
                          <option *ngFor="let s of availableTargetStates" [value]="s.value">{{ s.label }}</option>
                        </select>
                      </div>



                      <div class="info-row" *ngIf="currentState === 'Approved'">
                        <label for="" style="width: 140px; min-width: 140px; margin-right: 10px;">Reference License</label>
                        <input type="text"
                               [(ngModel)]="form.referenceLicense"
                               name="referenceLicense"
                               placeholder="Enter reference license">
                      </div>

                       <div class="info-row" *ngIf="currentState === 'Approved'">
                          <label for="" style="width: 140px; min-width: 140px; margin-right: 10px;">Agreement Type</label>
                            <select [(ngModel)]="form.agreementType" name="agreementType">
                               <!-- placeholder -->

                                <option *ngFor="let type of agreementTypeOptions" [value]="type">
                                  {{ type }}
                                </option>
                              </select>
                      </div>
                       <div class="info-row" *ngIf="currentState === 'Approved'">
                          <label for="" style="width: 140px; min-width: 140px; margin-right: 10px;">Agreement Duration</label>
                          <select [(ngModel)]="form.agreementDuration" name="agreementDuration">

                                <option *ngFor="let duration of agreementDurationOptions" [value]="duration">
                                  {{ duration }}
                              </select>
                      </div>
                       <div class="info-row" *ngIf="currentState === 'Approved'">
                          <label for="" style="width: 140px; min-width: 140px; margin-right: 10px;">Payment Status</label>
                        <input type="text"
                               [(ngModel)]="form.paymentStatus"
                               name="paymentStatus"
                               placeholder="Enter payment status">
                      </div>

                      <div class="info-row" *ngIf="currentState === 'Approved' && form.agreementDuration === 'Limited'">
                          <label for="" style="width: 140px; min-width: 140px; margin-right: 10px;">Expiry date</label>
                        <input type="date"
                               [(ngModel)]="form.dueDate"
                               name="dueDate"
                               [min]="todayStr"
                               [value]="currentDueDate">
                      </div>

                      <div *ngIf="form.newState === 'Approved'">
                        <div class="info-row">
                          <label for="" style="width: 140px; min-width: 140px; margin-right: 10px;">Reference License</label>
                          <input type="text"
                                [(ngModel)]="form.referenceLicense"
                                name="referenceLicense"
                                placeholder="Enter reference license">
                        </div>
                         <div class="info-row">
                              <label for="" style="width: 140px; min-width: 140px; margin-right: 10px;">Agreement Type</label>
                            <select [(ngModel)]="form.agreementType" name="agreementType">
                              <option value="">-- Select agreement type --</option>
                              <option *ngFor="let type of agreementTypeOptions" [value]="type">{{ type }}</option>
                            </select>
                          </div>
                        <div class="info-row">
                              <label for="" style="width: 140px; min-width: 140px; margin-right: 10px;">Agreement Duration</label>
                            <div style="display:flex; gap:20px; align-items: center;">
                              <label style="margin: 0;">
                                <input type="radio"
                                       name="agreementDuration"
                                       [value]="'Limited'"
                                       [(ngModel)]="form.agreementDuration"
                                       (change)="onAgreementDurationChange('Limited')">
                                Limited
                              </label>
                              <label style="margin: 0;">
                                <input type="radio"
                                       name="agreementDuration"
                                       [value]="'Unlimited'"
                                       [(ngModel)]="form.agreementDuration"
                                       (change)="onAgreementDurationChange('Unlimited')">
                                Unlimited
                              </label>
                            </div>
                        </div>

                        <div *ngIf="form.agreementDuration === 'Limited'">
                          <div class="info-row" style="margin-bottom: 10px;">
                            <label for="" style="width: 140px; min-width: 140px; margin-right: 10px;">Expiry date</label>
                            <input type="date"
                                   [(ngModel)]="form.dueDate"
                                   name="dueDate"
                                   [min]="todayStr"
                                   style="min-width: 140px; margin-right: 10px;" />
                          </div>
                        </div>

                        <div class="info-row" style="margin-top: 10px;">
                          <label for="" style="width: 140px; min-width: 140px; margin-right: 10px;">Payment Status</label>
                          <input type="text"
                                 [(ngModel)]="form.paymentStatus"
                                 name="paymentStatus"
                                 placeholder="Enter payment status" />
                        </div>
                      </div>
                    </div>



                  </div>

                  <!-- Right Column: Edit User Details -->
                  <div style="flex: 1; min-width: 0;">
                    <div class="title">
                      <label
                        [ngClass]="[colapsableLabelEditableFields ? 'active' : '', 'colapsable']"
                        (click)="toggleEditableFields()"
                        style="cursor: pointer;">
                        <h4 style="display: inline;">Edit User Details</h4>
                      </label>
                    </div>

                    <div [ngClass]="[colapsableDivEditableFields ? 'active' : '', 'colapsable']" [class.disabled]="currentState === 'Revoked'">
                      <div class="current-state-info">
                        <div *ngIf="users.length === 1" class="info-row">
                          <label for="" style="width: 140px; min-width: 140px; margin-right: 10px;">Role</label>
                          <input type="text"
                                 [(ngModel)]="form.role"
                                 name="role"
                                 placeholder="Enter role"
                                 [disabled]="currentState === 'Revoked'">
                        </div>
                        <div class="info-row">
                          <label for="" style="width: 140px; min-width: 140px; margin-right: 10px;">Organisation Name</label>
                          <input type="text"
                                 [(ngModel)]="form.organizationName"
                                 name="organizationName"
                                 placeholder="Enter organization name"
                                 [disabled]="currentState === 'Revoked'">
                        </div>
                         <!-- TODO use a dropdown for organisation type selection from keycloak -->

                        <div class="info-row">
                          <label for="" style="width: 140px; min-width: 140px; margin-right: 10px;">Organisation Type</label>
                          <input type="text"
                                 [(ngModel)]="form.organizationType"
                                 name="organizationType"
                                 placeholder="Enter organization type"
                                (ngModelChange)="syncGroupsFromSystemRoles()"

                                 [disabled]="currentState === 'Revoked'">
                        </div>
                       <!-- TODO use a dropdown for country selection  from keycloak -->
                        <div class="info-row">
                          <label for="" style="width: 140px; min-width: 140px; margin-right: 10px;">Country</label>
                          <input type="text"
                                 [(ngModel)]="form.country"
                                 name="country"
                                 placeholder="Enter country"
                                 [disabled]="currentState === 'Revoked'">
                        </div>


                        <div class="info-row">
                          <label style="width: 140px; min-width: 140px; margin-right: 10px;">System Roles</label>
                          <div style="width: calc(100% - 150px);">
                            <div *ngFor="let r of availableSystemRoles">
                              <label>
                                <input
                                  type="checkbox"
                                  [checked]="isSystemRoleSelected(r.value)"
                                  (change)="onSystemRoleToggle(r.value, $any($event.target).checked)"
                                  [disabled]="currentState === 'Revoked'">
                                {{ r.label }}
                              </label>
                            </div>
                          </div>
                        </div>

                        <div class="info-row">
                          <label style="width: 140px; min-width: 140px; margin-right: 10px;">Groups</label>
                          <textarea
                            [(ngModel)]="groupsText"
                            name="groupsText"
                            rows="3"
                            placeholder="/Spain/ReducedUser/&#10;/Portugal/FullUser/"
                            [disabled]="true"
                            style="width: 100%; box-sizing: border-box;">

                          </textarea>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>

          <div class="fields__btn">
            <div class="actions">
              <button type="button" class="gray" (click)="bsModalRef.hide()">Cancel</button>
              <button type="submit" class="blue" [disabled]="!isFormChanged()">Save</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<style>
  .due-date-btn {
    min-width: 110px;
    max-width: 120px;
    margin-right: 10px;
    margin-bottom: 0;
    text-align: center;
    flex: 0 0 auto;
  }
  .table-fields table {
    table-layout: fixed;
    width: 100%;
  }
  .table-fields th, .table-fields td {
    word-break: break-word;
    white-space: normal;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    padding: 6px 8px;
  }
  .table-fields th .header-content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    max-width: 180px;
    display: block;
  }
  .edit-details-bg {
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 15px 18px 15px 18px;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    /* Add space between border and inputs */
    box-sizing: border-box;
  }
  .edit-details-bg .dropdown-fields > div {
    padding-left: 2px;
    padding-right: 2px;
  }
  .edit-details-bg input[type="text"] {
    background: #fff;
    border: 1px solid #ced4da;
    border-radius: 3px;
    padding: 5px 8px;
    box-sizing: border-box;
    width: 100%;
  }
</style>

<style>
  .user-approval-table-scroll {
    max-height: 250px;
    overflow-y: auto;
    margin-top: 10px;
  }

  .user-approval-table-scroll table thead th {
    position: sticky;
    top: 0;
    background: #eeeeee;
    z-index: 2;
  }
</style>

